/*
 * THIS FILE WAS GENERATED BY "@atproto/lex". DO NOT EDIT.
 */

export * from './checkHandleAvailability.defs'
export { main as default } from './checkHandleAvailability.defs'
